import { QC_HUB_TABS, QC_TAB_PERMISSIONS } from "@intrasync/quality-control";
import {
  isQcTabVisible,
  NTX_HIDDEN_TAB_IDS,
  NEVER_GRANTED_CAPABILITY,
} from "./qualityControlTabPolicy";

/**
 * Apply the NTX tab policy to the QC hub's tab config.
 *
 * PRESENTATION ONLY. Nothing is unregistered: every service store and view
 * store stays mounted, and the hub Body renders strictly by id, so a hidden
 * tab's panel still resolves if something navigates to it.
 *
 * Both of the module's exported knobs are used, because either alone leaves a
 * hole:
 *
 *   `visible = false`  hides the tab in the strip today, while the host
 *                      installs no qcPermissions — but `resolveTabVisibility`
 *                      recomputes `visible` from the permission set the moment
 *                      one exists, which would bring the tab back.
 *   required capability  re-pointed at a grant NTX never issues, so the
 *                      permission path hides it too.
 *
 * `ModuleHubHeader` filters the strip on `visible !== false` — the hub
 * primitive supports this natively, exactly as it does for the inventory hub.
 * So this is a supported configuration, not a patch.
 *
 * Call once during root-store construction, before the hub first renders.
 */
export function applyQualityControlTabVisibility(): void {
  for (const tab of QC_HUB_TABS as readonly { id: string; visible?: boolean }[]) {
    tab.visible = isQcTabVisible(tab.id);
  }

  const permissions = QC_TAB_PERMISSIONS as Record<string, readonly string[]>;
  for (const tabId of NTX_HIDDEN_TAB_IDS) {
    permissions[tabId] = [NEVER_GRANTED_CAPABILITY];
  }
}

export default applyQualityControlTabVisibility;
